const server = {
    ip: process.env.REACT_APP_SERVER,
    port: process.env.REACT_APP_SERVER_PORT
};

export default server;